import { TelemetryEvent } from './telemetry-event';

export abstract class TelemetryPageViewEvent extends TelemetryEvent {
	public page: string;
}
